<template>
    <div class="calendar__calendar_dialog">
        <header class="calendar__calendar_dialog_header">
            <div class="columns is-vcentered">
                <div class="column">
                    <h2 class="calendar__calendar_dialog_header_name">{{ item.eventName }}</h2>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :name="'calendar-calendar-dialog-close'"
                        :icon="true"
                        :icon-name="'x'"
                        :icon-raw="true"
                        @click="$parent.switchDialog()"
                    ></component-button>
                </div>
            </div>
        </header>
        <div class="calendar__calendar_dialog_content">
            <ul>
                <li
                    v-for="(occurrence, index) in item.allOccurrences"
                    :key="index"
                >
                    <div class="calendar__calendar_dialog_content_time">
                        <div class="columns is-variable">
                            <div class="column">
                                <div class="calendar__calendar_dialog_content_time_date">
                                    {{ occurrence.date | calendarDate }}
                                </div>
                            </div>
                            <div class="column is-narrow">
                                <div class="calendar__calendar_dialog_content_time_hours">
                                    <v-icon name="clock"/>
                                    {{ occurrence.dateFrom | calendarTime }} - {{ occurrence.dateTo | calendarTime }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calendar__calendar_dialog_content_details">
                        <ul>
                            <li>
                                <div class="columns is-vcentered">
                                    <div class="column is-narrow">
                                        <div class="calendar__calendar_dialog_content_details_icon">
                                            <v-icon name="map-pin"/>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="calendar__calendar_dialog_content_details_desc">
                                            {{occurrence.roomName }}, {{ occurrence.venueName }}
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <template v-if="setTrainers(occurrence)">
                                <li>
                                    <div class="columns is-vcentered">
                                        <div class="column is-narrow">
                                            <div class="calendar__calendar_dialog_content_details_icon">
                                                <v-icon name="clipboard"/>
                                            </div>
                                        </div>
                                        <div class="column">
                                            <div class="calendar__calendar_dialog_content_details_desc">
                                                {{ setTrainers(occurrence) }}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <footer class="calendar__calendar_dialog_footer">
            <div class="calendar__calendar_dialog_footer_tags">
                <ul>
                    <li>
                        <component-status :status="item.bookingStatus"></component-status>
                    </li>
                    <li v-if="user.isEventCoordinator()">
                        <component-status :status="item.occurrenceStatus"></component-status>
                    </li>
                </ul>
            </div>
            <div class="columns is-vcentered">
                <div class="column">
                    <div class="calendar__calendar_dialog_footer_spaces">
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column is-narrow">
                                <div class="calendar__calendar_dialog_footer_spaces_icon">
                                    <v-icon name="users"/>
                                </div>
                            </div>
                            <div class="column">
                                <div class="calendar__calendar_dialog_footer_spaces_desc">
                                    {{ setAvailableSpaces() }} {{ $t('ebs.calendar.title.spacesAvailable') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="calendar__calendar_dialog_footer_actions">
                        <component-button
                            :to="{ name: 'ebs-session-show', params: { eventId: item.eventId, sessionId: item.occurrenceId } }"
                            :name="'calendar-calendar-dialog-footer-actions-view'"
                        >{{ $t('ebs.calendar.buttons.viewDetails') }}
                        </component-button>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { User } from '@/User'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    ComponentButton,
    ComponentStatus
  },
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData)
    }
  },
  name: 'calendar-calendar-dialog',
  props: {
    item: Object
  },
  methods: {
    setTrainers (occurrence) {
      let trainerNames = occurrence.trainers.map(trainer => trainer.trainerName)
      return trainerNames.join(', ')
    },
    setAvailableSpaces () {
      let spaces = this.item.occurrences.map(occurrence => occurrence.availableSpaces)
      if (spaces.length) {
        return Math.min(...spaces)
      }
      return 0
    },
    closeDialog (event) {
      const path = event.path || event.composedPath()

      if (!path) return
      let close = true
      for (let i = 0; i < path.length; i++) {
        if (!path[i].className) continue
        if (
          path[i].classList.contains('calendar__calendar_dialog') ||
        path[i].classList.contains('fc-event') ||
        path[i].classList.contains('fc-list-item')
        ) {
          close = false
        }
      }
      if (close) {
        this.$parent.dialogActive = false
      }
    }
  },
  mounted () {
    const overlay = document.getElementById('app')
    overlay.addEventListener('click', this.closeDialog)
  },
  beforeDestroy () {
    const overlay = document.getElementById('app')
    overlay.removeEventListener('click', this.closeDialog)
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/calendar/calendarcalendardialog";
</style>
